var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.8333 3.33331H5V16.6666H15V7.49998H10.8333V3.33331Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 6.66669L11.6663 1.66669H4.99967C4.08301 1.66669 3.34134 2.41669 3.34134 3.33335L3.33301 16.6667C3.33301 17.5834 4.07467 18.3334 4.99134 18.3334H14.9997C15.9163 18.3334 16.6663 17.5834 16.6663 16.6667V6.66669ZM14.9997 16.6667H4.99967V3.33335H10.833V7.50002H14.9997V16.6667Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosting);
export default __webpack_public_path__ + "static/media/posting.5c92f3e6d5e55770ca1c67cead656975.svg";
export { ForwardRef as ReactComponent };